import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScWagerLabelOuter = styled.div`
  @media not (${device.mobile}) {
    position: relative;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
`;

export const ScWagerLabel = styled.div`
  background-color: ${({ theme }) => theme.grayLightColor};
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  border-radius: 360px;
  overflow: hidden;

  cursor: pointer;

  @media not (${device.mobile}) {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    height: unset;
  }

  @media (${device.mobile}) {
    border-radius: 0 360px 360px 0;
  }

  .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
    height: 24px;
    width: 24px;

    i {
      font-size: 24px;
    }
  }

  .wager-info {
    display: flex;
    flex-direction: column;
    height: auto;
    white-space: nowrap;
    padding-top: 5px;
    padding-bottom: 5px;

    .wager {
      font-size: 12px;
      line-height: 18px;
    }

    .amount {
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      margin-top: -2px;
    }
  }
`;
